module.exports = __webpack_public_path__ + "0b8d910e4acdcaa2849c557b3359055b.pdf";